import { Controller } from "@hotwired/stimulus"

// ============================================================
// AddressTruncateController — 컨테이너 폭에 맞춘 중간 생략 표시
// ============================================================
// 블록체인 주소·TX 해시처럼 긴 고정 길이 문자열을 박스 너비에 딱 맞게
// 잘라서 "앞...뒤" 형태로 표시한다.
// ResizeObserver 로 컨테이너 폭 변경을 감지하여 자동 재계산.
//
// 사용법:
//   data-controller="address-truncate"
//   data-address-truncate-target="text"
//   data-full-text="<전체 문자열>"
// ============================================================
export default class extends Controller {
  static targets = ["text"]

  connect() {
    // ResizeObserver: 컨테이너 너비 변경 시 재계산
    this._observer = new ResizeObserver(() => this._apply())
    this._observer.observe(this.element)
    this._apply()
  }

  disconnect() {
    if (this._observer) this._observer.disconnect()
  }

  _apply() {
    if (!this.hasTextTarget) return
    const el       = this.textTarget
    const fullText = el.dataset.fullText || ""

    // 컨테이너 가용 폭 (px)
    const available = this.element.clientWidth
    if (available === 0) return

    // monospace 폰트에서 문자 1개 폭 측정
    const charPx = this._charWidth(el)
    if (charPx === 0) return

    // 한 줄에 들어갈 최대 문자 수
    const maxChars = Math.floor(available / charPx)

    if (fullText.length <= maxChars) {
      el.textContent = fullText
      return
    }

    // 중간 생략: 앞 60% / 뒤 40% 비율
    const usable  = Math.max(maxChars - 3, 4)
    const front   = Math.ceil(usable * 0.6)
    const back    = usable - front
    el.textContent = fullText.slice(0, front) + "…" + fullText.slice(-back)
  }

  // 해당 요소의 폰트 설정으로 문자 1개 폭(px)을 측정
  _charWidth(el) {
    const style    = window.getComputedStyle(el)
    const probe    = document.createElement("span")
    probe.style.cssText = [
      "visibility:hidden",
      "position:absolute",
      "white-space:nowrap",
      `font-family:${style.fontFamily}`,
      `font-size:${style.fontSize}`,
      `letter-spacing:${style.letterSpacing}`,
    ].join(";")
    probe.textContent = "x".repeat(20)
    document.body.appendChild(probe)
    const w = probe.getBoundingClientRect().width / 20
    probe.remove()
    return w
  }
}
